<template>
  <div>
    <Navbar></Navbar>
    <main>
      <div class="container">
        <div class="row draw-summary-row">
          <div class="col-12 d-flex justify-content-between align-items-center page-header">
            <h1>
              <span class="underline h1style" @click="goToDashboard()">{{event_name}}</span>
              <img class="path-separator" src="@/assets/images/path_separator.svg">
              <span class="underline" @click="goToDashboard()">Prizes</span>
              <img class="path-separator" src="@/assets/images/path_separator.svg">
              <span>{{this.prizeInfo.name}}</span>
              <img class="path-separator" src="@/assets/images/path_separator.svg">
              <span>Draw Summary</span>
            </h1>
          </div>
          <p class="summary">This draw is complete. Below is a recap of the results</p>
          <div class="draw-table-container flex-table">
            <div class="flex-table-header draw-header d-flex align-items-center">
              <div class="draw-column c-winner-name">Winner</div>
              <div class="draw-column c-first-name">first name</div>
              <div class="draw-column c-last-name">last name</div>
              <div class="draw-column c-email">email</div>
              <div class="draw-column c-attendee">attendee #</div>
              <div class="draw-column c-ticket">ticket #</div>
              <div class="draw-column c-draw-status">status</div>
              <div class="draw-column c-time">time</div>
              <div class="draw-column c-reject">reason for reject</div>
            </div>
            <!-- vue repeat -->
            <template v-for="(winner, index) in winners_list">
              <DrawTableRow
                :key="index"
                :winner="winner"
                :winnerCount="winner_count"
                :prizeId="prizeInfo.id"
                :prizeName="prizeInfo.name"
                :nonReSpinnable="nonReSpinnable"
                :drawn="prizeInfo.drawn"
              />
            </template>
          </div>
          <div v-if="!this.prizeInfo.drawn" class="draw-btns">
            <button
              class="draw-btn draw-btn-cancel"
              data-toggle="modal"
              data-target="#cancelModal"
            >Cancel</button>
            <button class="draw-btn draw-btn-confirm" @click="confirmDrawSummary()">Confirm</button>
          </div>
        </div>
      </div>
      <div id="leaveModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Are you Sure?</h2>
                <img
                  class="header-action modal-close"
                  src="@/assets/images/x.svg"
                  data-dismiss="modal"
                >
              </div>
              <p
                class="cancel-warning"
              >Leaving the draw will reset it back to default state and all winners info will be erased.</p>
              <div class="modal-btn-container">
                <button class="btn btn-default spin" data-dismiss="modal">Cancel</button>
                <button class="btn btn-primary" @click="cancelDraw()">Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="cancelModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <div class="title">
                <h2>Are you Sure?</h2>
                <img
                  class="header-action modal-close"
                  src="@/assets/images/x.svg"
                  data-dismiss="modal"
                >
              </div>
              <p
                class="cancel-warning"
              >Cancelling the draw will reset it back to default state and all winners info will be erased.</p>
              <div class="modal-btn-container">
                <button
                  class="btn btn-default spin"
                  data-toggle="modal"
                  data-target="#cancelModal"
                >Cancel</button>
                <button class="btn btn-primary" @click="cancelDraw()">Confirm</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import DrawTableRow from "@/components/DrawTableRow";
import Navbar from "@/components/Navbar";
import axios from "axios";
var $ = require("jquery");

export default {
  name: "DrawSummary",
  components: {
    DrawTableRow,
    Navbar
  },
  data() {
    return {
      event_name: localStorage.getItem("event_name"),
      winners_list: [],
      nonReSpinnable: [],
      winner_count: 1,
      prizeId: ""
    };
  },
  computed: {
    gevmeLink() {
      return (
        "https://dev.gevme.com/" +
        localStorage.getItem("org_id") +
        "/events/" +
        localStorage.getItem("event_id")
      );
    }
  },
  props: ["prizeInfo"],
  mounted() {
    $('[data-toggle="tooltip"]').tooltip();
    document.getElementsByTagName(
      "title"
    )[0].innerText = `Draw Summary • GEVME Lucky Draw`;
    if (!this.prizeInfo) {
      this.$router.push("/");
    }
    Event.$on("Home clicked", () => {
      if (!this.prizeInfo.drawn) $("#leaveModal").modal();
      else this.$router.push("/");
    });
    axios
      .post(
        window.ENDPOINT,
        {
          query: `
              query {
                prizes(where: {id: "${this.prizeInfo.id}"}) {
                  id
                  eventId
                  winnerCount
                  name
                  drawn
                  draws {
                    id
                    status
                    position
                    reason
                    createdAt
                    selectedAttendee
                    doneBy {
                      gevmeUser
                    }
                  }
                  author {
                    id
                    gevmeUser
                  }
                  lists
                  createdAt
                  updatedAt
                }
              }
            `
        },
        {
          headers: {
            Authorization: localStorage.getItem("gevme_token")
          }
        }
      )
      .then(
        function(response) {
          this.winner_count = response.data.data.prizes[0].winnerCount;
          this.prizeId = response.data.data.prizes[0].id;
          response.data.data.prizes[0].draws.forEach(element => {
            if (element.status != "start") {
              this.winners_list.push(element);
            }
            if (element.status !== "skip")
              this.nonReSpinnable.push(element.position);
          });
        }.bind(this)
      );
  },
  methods: {
    dismissModal() {
      $("#leaveModal").modal("hide");
    },
    goToDashboard() {
      if (!this.prizeInfo.drawn) $("#leaveModal").modal();
      else this.$router.push("/");
    },
    confirmDrawSummary() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                mutation {
                    updateDraw(status: "confirm", prizeId:"${this.prizeId}")
                }
            `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            if (response.data.data.updateDraw.drawn) {
              this.$router.push("/");
            }
          }.bind(this)
        );
    },
    cancelDraw() {
      axios
        .post(
          window.ENDPOINT,
          {
            query: `
                  mutation {
                      updateDraw(status: "cancel", prizeId:"${
                        this.prizeInfo.id
                      }")
                  }
              `
          },
          {
            headers: {
              Authorization: localStorage.getItem("gevme_token")
            }
          }
        )
        .then(
          function(response) {
            this.$router.push("/");
            // this.state = "result";
            // Object.assign(this.selected_attendee, response.data.data.createDraw.selectedAttendee);
          }.bind(this)
        );
    }
  }
};
</script>

<style scoped>
.flex-table-header {
  padding: 0 30px;
  display: inline-flex !important;
}

.flex-table-row {
  display: inline-flex !important;
}
.page-header {
  padding: 0;
}
p.summary {
  color: #323c48;
  font-weight: 600;
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 22px;
}
.flex-table-header .draw-column {
  font-size: 13px;
  font-weight: bold;
  color: #6c7176;
  text-transform: uppercase;
}

.c-winner-name {
  min-width: 80px;
}

.c-first-name,
.c-last-name {
  min-width: 100px;
}
.c-email {
  min-width: 160px;
}
.c-attendee,
.c-ticket {
  min-width: 90px;
}

.c-ticket {
  min-width: 160px;
  text-align: center;
  position: relative;
  right: 20px;
}

.underline {
  text-decoration: underline;
  cursor: pointer;
}

.c-draw-status {
  min-width: 145px;
}
.c-time {
  min-width: 120px;
}
.c-reject {
  min-width: 150px;
}
.draw-btns {
  margin: 30px 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.draw-btn {
  width: 150px;
  height: 40px;
  margin-left: 30px;
  border-color: transparent;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.draw-btn-cancel {
  background: transparent;
}
.draw-btn-confirm {
  background: #0088ff;
  color: white;
}
.draw-table-container {
  max-width: 100vw;
  padding-top: 0;
  overflow-x: auto;
}
.draw-header {
  /* display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%; */
}
.header-action.modal-close {
  cursor: pointer;
}

.modal-dialog {
  margin: 10rem auto;
  max-width: 670px;
}
.modal-body {
  padding: 45px;
}

.modal-body .title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.modal-body .title h2 {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 35px;
}

.modal-btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 35px;
}

.page-header .header-action.back {
  left: -35px;
}

.row.draw-summary-row {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DrawSummary.vue